<template>
  <div class="bg-slate-50 rounded-2xl p-4 border border-slate-200">
    <p class="text-slate-700 text-sm font-medium mb-3">העלו את הלוגו שלכם (אופציונלי)</p>

    <!-- Existing logo preview -->
    <div v-if="modelValue" class="flex flex-col items-center gap-3">
      <div class="relative w-28 h-28 rounded-2xl overflow-hidden border border-slate-200 bg-white flex items-center justify-center">
        <img :src="modelValue" alt="Logo" class="max-w-full max-h-full object-contain" />
      </div>
      <button
        type="button"
        class="text-xs text-slate-500 hover:text-pink-500 transition-colors flex items-center gap-1"
        @click="removeLogo"
      >
        <Trash2 class="w-3.5 h-3.5" />
        הסרת לוגו
      </button>
    </div>

    <!-- Upload area -->
    <label
      v-else
      :for="inputId"
      class="flex flex-col items-center justify-center w-full h-32 border-2 border-dashed border-slate-300 rounded-xl cursor-pointer bg-white hover:bg-slate-50 transition-colors"
    >
      <div v-if="uploadInProgress" class="flex flex-col items-center gap-2">
        <Loader2 class="w-6 h-6 text-pink-500 animate-spin" />
        <span class="text-xs text-slate-500">מעלה...</span>
      </div>
      <div v-else class="flex flex-col items-center gap-2">
        <ImagePlus class="w-6 h-6 text-slate-400" />
        <span class="text-xs text-slate-500">לחצו להעלאת לוגו</span>
        <span class="text-[10px] text-slate-400">PNG, JPG, WEBP</span>
      </div>
      <input
        :id="inputId"
        type="file"
        class="hidden"
        accept="image/png, image/jpeg, image/webp"
        @change="onFileSelected"
      />
    </label>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { useToast } from 'vue-toastification';
import { ImagePlus, Loader2, Trash2 } from 'lucide-vue-next';
import { SharedApi } from '@app/api/admin';
import { generateRandomId } from '@app/utils/strings';

defineProps<{
  modelValue: string | null;
}>();

const emit = defineEmits<{
  'update:modelValue': [value: string | null];
}>();

const toast = useToast();
const inputId = generateRandomId(10);
const uploadInProgress = ref(false);

const onFileSelected = async (event: Event) => {
  const target = event.target as HTMLInputElement;
  const file = target.files?.[0];
  if (!file) return;

  uploadInProgress.value = true;
  try {
    const formData = new FormData();
    formData.append('file', file);
    const urls = await SharedApi.uploadImages(formData);
    if (urls?.length) {
      emit('update:modelValue', urls[0]);
    }
  } catch (e) {
    console.error(e);
    toast.error('לא הצלחנו להעלות את הלוגו, נסו שוב');
  } finally {
    uploadInProgress.value = false;
    target.value = '';
  }
};

const removeLogo = () => {
  emit('update:modelValue', null);
};
</script>
